<template>
  <div :id="componentId" class="special-one-title" :style="wrapperStyle">
    <div class="special-one-title__bg" :style="bgStyle"></div>
    <div class="special-one-title__content">
      <div class="special-one-title__box" :style="boxStyle">
        <span class="special-one-title__text" :style="textStyle">{{ titleContent }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialOneTitle',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_title'
    }
  },
  data() {
    return {
      backgroundColor: '#fffff0',
      titleBackgroundImage: require('../assets/img/title_bg_green.png'),
      titleContent: '大会议程',
      titleColor: '#000000',
      titlePosition: 2
    };
  },
  computed: {
    wrapperStyle() {
      return {
        width: '2000px',
        marginLeft: '-300px'
      };
    },
    bgStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    },
    boxStyle() {
      const positionMap = {
        1: { marginLeft: '0', marginRight: 'auto' },
        2: { margin: '0 auto' },
        3: { marginLeft: 'auto', marginRight: '0' }
      };
      return {
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        ...positionMap[this.titlePosition] || positionMap[2]
      };
    },
    textStyle() {
      return {
        color: this.titleColor
      };
    }
  }
};
</script>

<style scoped>
.special-one-title {
  position: relative;
  width: 2000px;
  height: 70px;
  margin-left: -300px;
}

.special-one-title__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 2000px;
  height: 70px;
}

.special-one-title__content {
  position: absolute;
  top: 0;
  left: 300px;
  width: 1400px;
  height: 70px;
}

.special-one-title__box {
  width: 360px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.special-one-title__text {
  margin: 0;
  padding: 0;
  font-size: 36px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  line-height: 1;
}
</style>
